<template>
    <div class="ibox admin-message">
        <h1>{{ t_title }}</h1>

        <div class="ibox-heading table-responsive">
            <div class="d-flex d-flex-row align-center">
                <div class="search-field-container" style="max-width: 280px; width: 15vw; margin-right: 8px;">
                    <text-field
                        :value="search"
                        :label="t_search"
                        @input="handleSearchChange"
                    />
                </div>
                <v-btn type="button" class="d-flex align-center btn btn-primary m-r-sm" @click="addMessageModal()">
                    <i class="fa fa-plus fa-md m-r-sm"></i>&nbsp;{{ t_new_message }}
                </v-btn>
            </div>
        </div>
        <div class="ibox-content">
            <div style="margin-left: -12px; margin-bottom: 12px;">
                <admin-message-pagination
                    :page.sync="page"
                    :pages.sync="pages"
                    :limit.sync="limit"
                />
            </div>
            <div class="table-responsive w-100" style="overflow-x: revert">
                <table id="admin-message-table"
                       class="table table-striped table-bordered table-hover"
                        aria-label="admin message table"
                        style="margin-bottom: 0;">
                    <thead>
                        <tr>
                            <th class="col-md-3">{{ t_message }}</th>
                            <th class="col-md-2 text-center">{{ t_validity }}</th>
                            <th class="col-md-6">
                                <div style="max-height: 40px">
                                    <v-select-custom
                                        :label="t_projects"
                                        :value="projectFilterId"
                                        @input="handleProjectFilter"
                                        :items="projectFilterItems"
                                    />
                                </div>
                            </th>
                            <th class="col-md-1">{{ t_last_edit }}</th>
                            <th class="col-md-1">{{ t_actions }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(message, index) in messages"
                            :class="[index % 2 ? 'odd' : 'even', message.active ? '' : 'inactive']" role="row">
                            <td v-html="message.name"></td>
                            <td :class="['text-center', message.validity_status]">{{ message.validity_text }}</td>
                            <td>
                                <div v-for="project in message.displayed_projects">
                                    <div class="label label-primary m-r-xs m-b-xs pull-left">
                                        {{ project.name }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span class="text-center">{{ message.creator_name }}</span>
                                <span class="text-center">{{ message.updated_at }}</span>
                            </td>
                            <td>
                                <div class="btn-group actions">
                                    <v-btn type="button" :class="['btn btn-primary', message.can_edit ? '' : 'disabled']" @click.stop.prevent="editMessageModal(index)">
                                        <i class="fa-regular fa-pencil fa-md m-r-sm"></i>
                                        {{ t_edit }}
                                    </v-btn>
                                    <div class="btn-group border-left" v-if="message.can_edit">
                                        <v-btn aria-label="action menu" data-toggle="dropdown" class="btn btn-primary dropdown-toggle" aria-expanded="false">
                                            <span class="caret"></span>
                                        </v-btn>
                                        <ul class="dropdown-menu dropdown-menu-left">
                                            <li v-if="message.id > 19 || authSuperadmin"><a class="delete-message" @click.stop.prevent="deleteMessageModal(index)">{{ t_delete }}</a></li>
                                            <li><a class="activate-message" @click.stop.prevent="toggleMessageActive(index)">{{ message.active ? t_deactivate : t_activate}}</a></li>
                                            <li v-if="authSuperadmin"><a class="reactivate-message" @click.stop.prevent="clear_confirms(index)">{{ t_reactivate }}</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th class="col-md-3">{{ t_message }}</th>
                            <th class="col-md-2 text-center">{{ t_validity }}</th>
                            <th class="col-md-6">{{ t_projects }}</th>
                            <th class="col-md-1">{{ t_last_edit }}</th>
                            <th class="col-md-1">{{ t_actions }}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div style="margin-left: -12px; margin-top: 12px;">
                <admin-message-pagination
                    :page.sync="page"
                    :pages.sync="pages"
                    :limit.sync="limit"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import toaster from "../../common/toaster";
    import TextField from "../../common/text-field.vue";

    export default {

        props: [
            'authSuperadmin',
        ],
        components: {
            TextField,
            adminMessagePagination: require ('./pagination.vue').default,
        },
        watch: {
            page: function() {
                this.load();
            },
            limit: function() {
                this.load();
            },
            search: debounce(function() {
                this.load();
            }),
        },
        data() {
            return {
                t_load_error:           Lang.langGet("Failed to load table."),
                t_title:                Lang.langChoice("System Message|System Messages", 2),
                t_message:              Lang.langGet("Message"),
                t_validity:             Lang.langGet("Validity"),
                t_projects:             Lang.langChoice("Project|Projects", 2),
                t_actions:              Lang.langChoice("Action|Actions", 2),
                t_edit:                 Lang.langGet("Edit"),
                t_delete:               Lang.langGet("Delete"),
                t_new_message:          Lang.langGet("New System Message"),
                t_all_projects:         Lang.langGet("all projects"),
                t_activate:             Lang.langGet("Activate"),
                t_deactivate:           Lang.langGet("Deactivate"),
                t_activate_success:     Lang.langGet("Activating System Message successful"),
                t_activate_failed:      Lang.langGet("Activating System Message failed"),
                t_deactivate_success:   Lang.langGet("Deactivating System Message successful"),
                t_deactivate_failed:    Lang.langGet("Deactivating System Message failed"),
                t_last_edit:            Lang.langGet("Last edited"),
                t_search:               Lang.langGet('Search'),
                t_reactivate:           Lang.langGet("Revoke OKs"),
                t_reactivate_user:      Lang.langGet("Revoke OKs (User)"),

                projectFilterId:        -1,
                projectFilterMapping:   [],
                messages:               [],
                search:                 '',
                page:                   0,
                pages:                  0,
                limit:                  25,
            }
        },
        computed: {
            projectFilterItems() {
                const projects = [{value: -1, text: this.t_all_projects}];
                this.projectFilterMapping.forEach(project => {
                    projects.push({value: project[0], text: project[1]});
                });

                return projects;
            }
        },
        methods: {
            getProjectId() {
                if (!this.projectFilterId) return -1;
                if (this.projectFilterId === -1) return -1;
                return this.projectFilterMapping.find(project => project[0] === this.projectFilterId)[0];
            },
            load: debounce(function() {
                axios.post('system-messages/get-table', {
                    project_to_filter:  this.getProjectId(),
                    search:             this.search,
                    page:               this.page,
                    limit:              this.limit,
                }).then((response) => {
                    this.messages = response.data.data;
                    this.pages    = response.data.pages;
                    this.projectFilterMapping = response.data.projectFilterMapping;
                    this.$forceUpdate();
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_error);
                });
            }, 500),
            handleProjectFilter(filter) {
                this.projectFilterId = filter;
                this.load();
            },
            addMessageModal: function() {
                EaseEventBus.fire('systemMessageAdd');
            },
            editMessageModal: function(index) {
                const {can_edit, id} = this.messages[index];
                if(can_edit) {
                    EaseEventBus.fire('systemMessageEdit', {id: id});
                }
            },
            deleteMessageModal: function(index) {
                const data = this.messages[index];

                const params = {
                    ids: [data.id],
                    name: data.name,
                    entityName: 'systemMessage',
                    message: `Do you want to remove ${data.name}?`,
                    url: 'system-messages/delete',
                    reloadEventName: 'reloadSystemMessageTable'
                };

                EaseEventBus.fire('confirmDeleteDialog', params);
            },
            toggleMessageActive: function(index) {
                let active = this.messages[index].active;
                axios.post('system-messages/toggle-active', {
                    id: this.messages[index].id
                }).then(() => {
                    toaster.success(active ? this.t_deactivate_success : this.t_activate_success);
                    this.load();
                }).catch(() => {
                    toaster.error(active ? this.t_deactivate_failed : this.t_activate_failed);
                });
            },
            clear_confirms(index, user_only = false) {
                axios.post('system-messages/clear-confirms', {
                    id: this.messages[index].id,
                    user_only: user_only
                }).then(() => {
                    toaster.success(Lang.langGet("System Message saved successfully."));
                }).catch((error) => {
                    if(error.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(Lang.langGet("Failed to save System Message."));
                });
            },
            handleSearchChange(value) {
                this.serach = value;
            }
        },
        mounted() {
            this.load();
            EaseEventBus.listen('reloadSystemMessageTable', () => {
                this.load();
            });
        }
    }

</script>


<style scoped>
    .table-responsive .btn-group.actions {
        display: flex;
    }
    .table-responsive .btn-group.actions .dropdown-menu > li > a {
        color: inherit;
        padding: 7px 10px;
    }

    .table-responsive .btn-group.actions {
        position: relative;
    }
    .table-responsive .btn-group.actions .btn-group {
        position: static;
        margin-left: 0;
        font-size: 0;
    }
    .table-responsive .btn-group.actions .dropdown-menu {
        min-width: 0;
        width: 100%;
    }
    .table-responsive .btn-group.actions .dropdown-menu.actions {
        left: -71px;
    }
    .table-responsive .btn-group.actions .dropdown-menu > li > a,
    .table-responsive .btn-group.multi-actions .dropdown-menu > li > a {
        background-color: #003371;
        color: #ffffff;
    }
    .table-responsive .btn-group.actions .dropdown-menu > li > a:hover,
    .table-responsive .btn-group.multi-actions .dropdown-menu > li > a:hover {
        background-color: #5485c1;
        color: #7f99b8;
    }

    #admin-message-table {
        thead tr th,
        tbody tr td {
            vertical-align: middle !important;
        }
    }

    #admin-message-table > tfoot {
        min-height: 40px;
    }

    .table > tfoot > tr > td, .table > tfoot > tr > th {
        border-top: 1px solid rgba(0, 0, 0, .38);
    }

    .table > tbody > tr:last-of-type > td {
        border-bottom: 1px solid rgba(0, 0, 0, .38);
    }

    .table > tfoot > tr {
        background: #f5f5f6;
    }
</style>
